
import { useState, useEffect, useRef } from 'react'
import type { AnyAction } from 'redux'

import { useDispatch } from 'store/hooks'




export type UseQuerySelectResult<T> = {
  isLoading: boolean
  isRefetching: boolean
  refetch: (params?: Partial<T>) => void
}

export type UseQuerySelectOptions = {
  enabled?: boolean
}

export const useQuerySelect = <T>(
  action: (params: T, callback?: () => void) => AnyAction,
  params: T,
  options?: UseQuerySelectOptions
): UseQuerySelectResult<T> => {
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isRefetching, setIsRefetching] = useState<boolean>(false)
  const prevParamsRef = useRef<T>()

  useEffect(() => {
    // Check if params actually changed
    const paramsChanged = JSON.stringify(prevParamsRef.current) !== JSON.stringify(params)
    
    if (options?.enabled === false) {
      setIsLoading(false)
    } else if (paramsChanged) {
      setIsLoading(true)
      const actionResult = action(params, () => {
        setIsLoading(false);
      });
      dispatch(actionResult);
      prevParamsRef.current = params
    }
  }, [options?.enabled, params, dispatch, action])

  const refetch = (refetchParams?: Partial<T>) => {
    setIsRefetching(true)

    dispatch(
      action(
        {
          ...params,
          ...refetchParams,
        } as T,
        () => {
          setIsRefetching(false);
        }
      )
    )
  }
  
  return {
    isLoading,
    isRefetching,
    refetch,
  }
}
